import {  Directive, ViewContainerRef} from "@angular/core";

@Directive({
    selector: 'pane',
    standalone: false,
  })
  export class Pane {
    constructor (public vcr: ViewContainerRef) {}
  }
  